import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { SiteContext } from "../contexts/SiteContext";
import { useUser } from "../contexts/UserContext";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";

export default function SiteHeader({ onToggleSidebar }) {
  const { user, loading: userLoading } = useUser();
  const { options, loading: siteLoading } = useContext(SiteContext);
  const [isExpanded, setIsExpanded] = useState(false);

  if (userLoading || siteLoading) {
    return (
      <Navbar bg="white" expand="md" className="border-bottom">
        <Container>
          <div className="placeholder-glow">
            <span className="placeholder col-3"></span>
          </div>
        </Container>
      </Navbar>
    );
  }

  return (
    <>
      {/* Main Header */}
      <Navbar
        bg="white"
        expand="md"
        className="border-bottom"
        expanded={isExpanded}
      >
        <Container>
          {/* Brand Title */}
          <Navbar.Brand
            as={Link}
            to="/"
            className="fw-bold text-inchworm me-auto"
          >
            {options.title || "E-Learning Platform"}
          </Navbar.Brand>

          {/* Mobile Toggle Button */}
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setIsExpanded(!isExpanded)}
          />

          <Navbar.Collapse id="basic-navbar-nav">
            {/* Right nav */}
            <Nav className="ms-auto align-items-center">
              {!user ? (
                <>
                  <Nav.Item className="me-2">
                    <Link
                      to="/login"
                      className="btn btn-outline-dark rounded-0"
                      onClick={() => setIsExpanded(false)}
                    >
                      Log in
                    </Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Link
                      to="/signup"
                      className="btn btn-inchworm text-dark rounded-0"
                      onClick={() => setIsExpanded(false)}
                    >
                      Sign up
                    </Link>
                  </Nav.Item>
                </>
              ) : (
                <Dropdown as={Nav.Item}>
                  <Dropdown.Toggle
                    as={Nav.Link}
                    className="d-flex align-items-center"
                    id="user-dropdown"
                  >
                    <i className="bi bi-person-circle fs-4 text-dark me-2"></i>
                    <span className="d-none d-md-inline">
                      {user.name || user.email}
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu align="end">
                    <Dropdown.Item
                      as={Link}
                      to="/account"
                      onClick={() => setIsExpanded(false)}
                      className="d-flex align-items-center"
                    >
                      <i className="bi bi-person me-2"></i>
                      Account
                    </Dropdown.Item>

                    {(user.role === "distributor" ||
                      user.role === "superadmin") && (
                      <Dropdown.Item
                        as={Link}
                        to="/account/aff-dashboard"
                        onClick={() => setIsExpanded(false)}
                        className="d-flex align-items-center"
                      >
                        <i className="bi bi-cash-coin me-2"></i>
                        Affiliate Dashboard
                      </Dropdown.Item>
                    )}

                    <Dropdown.Divider />

                    <Dropdown.Item
                      as={Link}
                      to="/logout"
                      onClick={() => setIsExpanded(false)}
                      className="d-flex align-items-center"
                    >
                      <i className="bi bi-box-arrow-right me-2"></i>
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Below-Header Menu */}
      <div className="bg-inchworm">
        <Container>
          <div className="d-flex justify-content-between align-items-center py-2">
            {/* Left-aligned Links */}
            <div className="d-flex gap-4">
              <Link
                to="/"
                className="text-dark text-decoration-none fw-medium d-flex align-items-center"
              >
                <i className="bi bi-house me-1"></i>
                Home
              </Link>
              <Link
                to="/learn"
                className="text-dark text-decoration-none fw-medium d-flex align-items-center"
              >
                <i className="bi bi-journals me-1"></i>
                Lessons
              </Link>
            </div>

            {/* Right-aligned Links */}
            <div className="d-flex gap-4">
              <Link
                to="/premium"
                className="text-dark text-decoration-none fw-medium d-flex align-items-center"
              >
                <i className="bi bi-star me-1"></i>
                Premium
              </Link>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}
